import { render, staticRenderFns } from "./addressItem.vue?vue&type=template&id=3ebed306&scoped=true"
import script from "./addressItem.vue?vue&type=script&lang=js"
export * from "./addressItem.vue?vue&type=script&lang=js"
import style0 from "./addressItem.vue?vue&type=style&index=0&id=3ebed306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebed306",
  null
  
)

export default component.exports